module.exports = __webpack_public_path__ + "img/form-bg3.830d4f88.png";